<div mat-dialog-content>
  <div class="mat-dialog-content">
    @if (isLoading) {
      <app-loading-list></app-loading-list>
    }
    @if (!isLoading) {
      <div class="title-header">
        <h1><b>Materiais do kit</b></h1>
      </div>
      <h3>{{this.kit.kit.kitName}}</h3>
      <h5>Manipulação</h5>
      <div class="row">
        @for (item of this.kit.items; track item; let index = $index) {
          <div class="col-12">
            <div class="col-7">
              <mat-form-field appearance="outline">
                <mat-label>Material</mat-label>
                <input matInput type="text" readonly [value]="item.codeWithName">
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline">
                <mat-label>Quantidade</mat-label>
                <input matInput type="number" readonly [value]="item.amount">
              </mat-form-field>
            </div>
          </div>
        }
        @for (item of this.kit.medicines; track item; let index = $index) {
          <div class="col-12">
            <div class="col-7">
              <mat-form-field appearance="outline">
                <mat-label>Medicamento</mat-label>
                <input matInput type="text" readonly [value]="item.medicineDescription">
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field appearance="outline">
                <mat-label>Quantidade</mat-label>
                <input matInput type="number" readonly [value]="item.amount">
              </mat-form-field>
            </div>
          </div>
        }
      </div>
      @if (this.kit.items != undefined && this.kit.items.length == 0 && this.kit.medicines != undefined && this.kit.medicines.length == 0) {
        <app-empty-list></app-empty-list>
      }
    }

  </div>
</div>
<div mat-dialog-footer class="footer-modal">
  <div class="footer-audit-modal-warning col-6">
    <button mat-flat-button color="accent" class="btn-block" (click)="close()">
      <span>Voltar</span>
    </button>
  </div>
</div>